export const defaultInvestorQuestions = [
  {
    id: 'type',
    mandatory: true,
    placeholder: 'type',
    title: 'type',
    type: 'select',
    answers: ['venture_capital', 'funds_of_funds', 'debt', 'other'],
  },
  {
    id: 'minPerProject',
    mandatory: false,
    placeholder: 'minPerProject',
    title: 'minPerProject',
    type: 'number',
  },
  {
    id: 'maxPerProject',
    mandatory: false,
    placeholder: 'maxPerProject',
    title: 'maxPerProject',
    type: 'number',
  },
  {
    id: 'phase',
    mandatory: false,
    placeholder: 'phase',
    title: 'phase',
    type: 'list',
    answers: ['preseed', 'seed', 'early', 'growth', 'expansion'],
  },
];
